<template>
  <div class="head">
    <div class="inner">
      <h1><a href="javascript:;" @click="childMethod"><img src="https://www.itcast.cn/2018czgw/images/logo2.png"></a></h1>
      <img src="https://www.itcast.cn/2020gw/images/slogan2.jpg" class="slogan">
      <ul>
        <li><a href="javascript:;" @click="childMethod">IP短视频带货学科概述</a></li>
        <li><a href="javascript:;" @click="childMethod">课程大纲</a></li>
        <li><a href="javascript:;" @click="childMethod">报名流程</a></li>
        <li><a href="javascript:;" @click="childMethod">免费资源领取</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  methods: {
    childMethod() {
      this.$parent.itcastClick();
    }
  }
};
</script>

<style lang="scss" scoped>

  .head{
    width:100%;
    height: 83px;
    background: #fff;
    overflow:hidden;
    .inner{
      width:1200px;
      margin:0 auto;
      overflow:hidden;
    }
    h1{
      float:left;
      img{width: 180px;margin-top: 15px;}
    }
    .slogan{
      float: left;
      margin: 21px 0 0 15px;
      border-left: 1px #dedede solid;
      padding-left: 17px;
    }
    ul{
      float:right;
      overflow:hidden;
      overflow:hidden;
      li{
        float:left;
        margin-left:20px;
        font-size:16px;
        line-height: 83px;
        margin-left: 50px;
        a{
          color:#636363;
          text-decoration:none;
        }
        a:hover{color:#2d81ff;}
      }
    }
  }
</style>
